import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../routes.json';
import { normalizeRoute } from '../utils/routeHelpers';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    // placeholder: integrate backend API later
    setSent(true);
  };

  return (
    <section className="tool-area">
      <div className="tool-controls">
         <h1>Contact Us</h1> 
        <div className="usage">Contact Us</div>
      </div>

      <div className="page-content" style={{ marginTop: 12, color: '#6b7280' }}>
        <p>
          Use this page to get in touch with the OneAI team for support, partnerships, and press inquiries. We welcome feedback about the tools, feature requests, and bug reports. Messages are routed to the right team so we can respond efficiently.
        </p>
        <p>
          When contacting us, include context (a short description, example inputs, and screenshots if helpful) so we can reproduce issues and provide practical assistance. We aim to respond to support requests within a few business days.
        </p>
        <ul style={{ marginTop: 8 }}>
          <li>Support & troubleshooting for tools and account issues.</li>
          <li>Partnership or press inquiries — tell us your idea.</li>
          <li>Feature requests and feedback to improve the product.</li>
        </ul>

        <h3 style={{ marginTop: 12 }}>Contact information</h3>
        <p>
          Email: <a href="mailto:info.onehubtech@gmail.com">info.onehubtech@gmail.com</a>
        </p>
        <p>
          Phone: <a href="tel:+917010512892">+91 70105 12892</a>
        </p>
      </div>

      <div className="tool-grid">
        <div className="panel panel-left">
          <h3 style={{ marginTop: 0 }}>Send us a message</h3>
          {sent ? (
            <div style={{ padding: 12 }}>
              <p>Thanks — we received your message and will reply soon.</p>
              <button
                className="btn"
                onClick={() => {
                  setSent(false);
                  setForm({ name: '', email: '', message: '' });
                }}
              >
                Send another
              </button>
            </div>
          ) : (
            <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <input
                className="input-area"
                style={{ minHeight: 40 }}
                placeholder="Your name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
              />
              <input
                className="input-area"
                style={{ minHeight: 40 }}
                placeholder="Email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
              />
              <textarea
                className="input-area"
                placeholder="Message"
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                required
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button type="submit" className="btn primary">
                  Send Message
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      {/* 🔗 External Outgoing Link (Fix for Ahrefs "No outgoing links") */}
      <div style={{ marginTop: 25 }}>
        <p style={{ color: '#6b7280' }}>
          To explore more advanced AI work, visit{' '}
          <a 
            href="https://openai.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ color: '#4f46e5', fontWeight: '600' }}
          >
            OpenAI
          </a>.
        </p>
      </div>

      {/* Internal outgoing links (SPA) */}
      <div style={{ marginTop: 20 }}>
        <h4>Explore more</h4>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Link to={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost">Try the Humanizer</Link>
          <Link to={normalizeRoute(ROUTES.blog.path)} className="btn ghost">Visit our Blog</Link>
          <Link to={normalizeRoute(ROUTES.about.path)} className="btn ghost">About Us</Link>
        </div>
      </div>
    </section>
  );
}
